import script from "./Code.vue?vue&type=script&setup=true&lang=js"
export * from "./Code.vue?vue&type=script&setup=true&lang=js"

import "./Code.vue?vue&type=style&index=0&id=b260b484&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b260b484"]])

export default __exports__